var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"changeLanguage":_vm.changeLanguage,"changePage":_vm.changePage,"lang":_vm.lang}}),_c('LeftSide',{staticClass:"position-left",attrs:{"language":_vm.lang}}),_c('RightSide',{staticClass:"position-right",attrs:{"page":_vm.page,"lang":_vm.lang,"changepage":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }